import useAuthStore from '@/stores/useAuthStore'
import useLogout from '@/hooks/useLogout'
import { Popover, Typogaphy } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

const AccountDropdown = () => {
    const { t } = useTranslation()
    const { employee } = useAuthStore()
    const { handleLogout, isPending } = useLogout()
    const [showDropdown, setShowDropdown] = useState(false)

    if (!employee) return null

    const displayName = employee.employee_name || 'User'
    const userInitial = displayName.charAt(0).toUpperCase()

    const handleToggleDropdown = () => {
        setShowDropdown((prev) => !prev)
    }

    return (
        <Popover
            interactive
            visible={showDropdown}
            onClickOutside={() => setShowDropdown(false)}
            placement="bottom-end"
            appendTo={document.body}
            render={(attrs) => (
                <div
                    className="bg-white rounded-lg shadow-lg border border-gray-200 w-64 pt-2"
                    {...attrs}
                >
                    <div className="px-4 py-3 border-b border-gray-100">
                        <div className="flex items-center gap-3">
                            <div
                                className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold text-lg"
                                aria-label={`Avatar for ${displayName}`}
                            >
                                {userInitial}
                            </div>
                            <div className="flex-1 min-w-0">
                                <Typogaphy
                                    size="medium"
                                    className="font-semibold text-gray-900 truncate"
                                >
                                    {employee?.employee_name}
                                </Typogaphy>
                                <Typogaphy
                                    size="small"
                                    className="text-gray-500 truncate"
                                >
                                    {employee?.employee_email_company}
                                </Typogaphy>
                                <Typogaphy
                                    size="small"
                                    className="text-gray-400 truncate"
                                >
                                    {employee?.position_name} •{' '}
                                    {employee?.department_name}
                                </Typogaphy>
                            </div>
                        </div>
                    </div>

                    <div className="py-1">
                        <button
                            onClick={() => {
                                setShowDropdown(false)
                                handleLogout()
                            }}
                            disabled={isPending}
                            className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                />
                            </svg>
                            {isPending ? t('logging_out') : t('logout')}
                        </button>
                    </div>
                </div>
            )}
        >
            <div className="cursor-pointer" onClick={handleToggleDropdown}>
                <div
                    className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold text-sm"
                    aria-label={`Avatar for ${displayName}`}
                >
                    {userInitial}
                </div>
            </div>
        </Popover>
    )
}

export default AccountDropdown
